<template>
  <div v-if="product.attributes.length > 0">
    <div
      v-for="(attribute, index) in product.attributes"
      :key="index"
    >
      <button
        v-b-toggle="'collapse' + index"
        class="attribute-name btn text-uppercase"
      >
        {{ $tradukojTranslate(attribute.name) }}
        <font-awesome-icon
          icon="chevron-down"
          class="ml-2"
        ></font-awesome-icon>
      </button>
      <b-collapse :id="'collapse' + index">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-dompurify-html="attribute.html_content" class="attribute-content p-3"></div>
      </b-collapse>
    </div>
  </div>
</template>


<script>
export default {
  name: "product-attributes",
  props: {
    product: Object,
  },
};
</script>


<style lang="scss" scoped>
.attribute-content {
  border: 1px solid $border-color;
  color: $text-fourth-color;
}

.attribute-name {
  font-size: $font-size-medium * 1.1;
}

.btn:focus {
  box-shadow: none;
}
</style>
